import { property } from '@pristine-ts/metadata';
import { EventTypeEnum } from '../enums/event-type.enum';

export class EventIndexModel<T> {
  @property()
  id: string;

  @property()
  organizationId: string;

  @property()
  eventType: EventTypeEnum;

  @property()
  userId?: string;

  @property()
  userFirstName?: string;

  @property()
  userLastName?: string;

  @property()
  userEmail?: string;

  @property()
  createdAt: Date;

  @property()
  payload: T;
}
